/* KK31 Cyber Monday page (Figma KK-31, 2026-10-12).
   Moves the "CYBER MEOWDAY ✦ BUY 1 GET 1 FREE" bar from the buy box to the
   top of the page (above the header group). The shine / glitch animation is
   CSS only (kk31-offer.css). */
(function () {
  'use strict';

  function placeBanner() {
    var banner = document.querySelector('[data-kk31-banner]');
    if (!banner) return;
    var header = document.getElementById('shopify-section-group-header-group')
      || document.querySelector('.shopify-section-group-header-group');
    var target = header || document.getElementById('MainContent');
    if (target && target.parentNode && banner.nextElementSibling !== target) {
      target.parentNode.insertBefore(banner, target);
    }
    banner.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBanner);
  } else {
    placeBanner();
  }
  // Theme editor re-renders the section; re-place the (new) banner.
  document.addEventListener('shopify:section:load', placeBanner);
})();
